import { Toaster as SonnerToaster, toast } from 'sonner'
import type { ComponentProps } from 'react'

export type ToasterProps = ComponentProps<typeof SonnerToaster>

/**
 * Token-aligned sonner Toaster. richColors is off (semantic tones come from the
 * registry, not sonner's own palette); positioned bottom-right.
 */
export function Toaster(props: ToasterProps) {
  return (
    <SonnerToaster
      position="bottom-right"
      richColors={false}
      toastOptions={{
        classNames: {
          toast: 'bg-card text-card-foreground border border-border rounded-lg shadow-card text-sm',
          description: 'text-muted-foreground',
          actionButton: 'bg-primary text-primary-foreground',
          cancelButton: 'bg-muted text-muted-foreground',
        },
      }}
      {...props}
    />
  )
}

export { toast }
